import classnames from 'classnames';
import { PropsWithChildren, useState } from 'react';

import styles from './Radio.module.scss';
import { RadioProps } from './Radio.types';

/** @deprecated use `RadioGroup` instead */
export const Radio = ({
  vertical,
  disabled,
  focus,
  error,
  tabIndex,
  onChange,
  checked,
  small,
  children,
}: PropsWithChildren<RadioProps>) => {
  const [active, setActive] = useState(false);

  return (
    <div
      className={classnames(styles.container, {
        [styles.vertical]: vertical,
        [styles.disabled]: disabled,
        [styles.active]: active,
        [styles.focus]: focus,
        [styles.error]: error,
        [styles.checked]: checked,
      })}
      onClick={() => {
        if (disabled) return;
        onChange(!checked);
      }}
      tabIndex={tabIndex ?? (disabled ? undefined : 0)}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setActive(true);
        }
      }}
      onKeyUp={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setActive(false);
          onChange(!checked);
        }
      }}
    >
      <div className={classnames(styles.radioContainer)}>
        <div className={classnames(styles.radioButton)} />
      </div>
      <div className={classnames(styles.label, { [styles.small]: small })}>{children}</div>
    </div>
  );
};
